var texts = {
  'sv-SE': {
    tripadvisor: 'Betyg från Tripadvisor'
  },
  'nb-NO': {
    tripadvisor: 'Vurdering fra Tripadvisor'
  },
  'da-DK': {
    tripadvisor: 'Bedømmelse fra Tripadvisor'
  },
  'fi-FI': {
    tripadvisor: 'Arvostelut Tripadvisorista'
  },
  en: {
    tripadvisor: 'Tripadvisor rating'
  }
};
var texts$1 = texts;

export { texts$1 as default };
//# sourceMappingURL=TripadvisorRating.texts.js.map
